var _rect, _rect2, _rect3, _rect4, _rect5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlatform = function SvgPlatform(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 8,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 22,
    width: 40,
    height: 40,
    rx: 6,
    fill: "url(#paint0_linear_2215_10449)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 66,
    width: 40,
    height: 40,
    rx: 6,
    fill: "url(#paint1_linear_2215_10449)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 22,
    width: 40,
    height: 40,
    rx: 6,
    fill: "url(#paint2_linear_2215_10449)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 66,
    width: 40,
    height: 40,
    rx: 6,
    fill: "url(#paint3_linear_2215_10449)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2215_10449",
    x1: 32.6024,
    y1: 44.069,
    x2: 60.7455,
    y2: -3.30344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2215_10449",
    x1: 32.6024,
    y1: 88.069,
    x2: 60.7455,
    y2: 40.6966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2215_10449",
    x1: 76.6024,
    y1: 44.069,
    x2: 104.745,
    y2: -3.30344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2215_10449",
    x1: 76.6024,
    y1: 88.069,
    x2: 104.745,
    y2: 40.6966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79C2FF"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlatform);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "platform.86e0759381adad4dd5508827ed8269ea.svg";